import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

import OTP from './components/login/OTP'
import PhoneNumber from './components/login/phoneNumber'

import { LoginContext } from './context/LoginContext'

import logo from './logo.png'
import { FaTelegram, FaInstagram } from 'react-icons/fa'

export default function Login() {
  const [phonenumber, setPhonenumber] = useState(0)
  const [loginForm, setLoginForm] = useState(true)
  const [otp, setOtp] = useState(false)

  //force logedout user
  localStorage.removeItem('user')

  return (
    <>
      {document.body.classList.add('xs-white')}
      <Helmet>
        <title>سکانس | ورود</title>
      </Helmet>
      <LoginContext.Provider
        value={{
          phonenumber,
          setPhonenumber,
          loginForm,
          setLoginForm,
          otp,
          setOtp
        }}
      >
        <div className='full-bg'>
          <div className='centerBox'>
            <div className='flex_holder'>
              <div className='logo'>
                <img src={logo} alt='' />
              </div>
              <div className='loginBox'>
                {loginForm && <PhoneNumber />}
                {otp && <OTP />}
              </div>
              <br />
              <div className='socialMedia'>
                <div className='telegBtn'>
                  <a target='_blank' href='https://t.me/sekaans_support'>
                    <FaTelegram /> پشتیبانی تلگرام
                  </a>
                </div>
                {/* <div className='instaBtn'>
                  <Link target='_blank'>
                    <FaInstagram /> اینستاگرام
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </LoginContext.Provider>
    </>
  )
}
